export default {"src":"/_next/static/image/public/images/ic_close_prescription_modal.d701a5b24aaf83daf2f9babe9219d082.svg","height":16,"width":16};